<template>
	<div>
		<div v-if="$slots.label" class="text-brand-neutral-7 mb-2 text-base font-semibold">
			<slot name="label"></slot>
		</div>
		<div class="w-full flex items-center gap-2">
			<slot v-if="$slots.beforeInput" name="beforeInput" class="flex"></slot>
			<div class="bg-brand-neutral-2 rounded-xl p-4 flex gap-3 items-center justify-center w-full">
				<div v-if="$slots.prependIcon" class="flex">
					<slot name="prependIcon"></slot>
				</div>
				<input
					ref="inputRef"
					class="placeholder:text-neutral-4-50 text-neutral-4 w-full bg-transparent"
					v-model="inputModel"
					v-mask="options"
					v-bind="$attrs"
					@keyup="handleKeyUp"
				/>
				<div v-if="$slots.appendIcon" class="flex">
					<slot name="appendIcon"></slot>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { reactive } from 'vue'
import type { MaskInputOptions } from 'maska'

const inputRef = ref<HTMLInputElement | null>(null)
const inputModel = defineModel()
const props = defineProps<{
	mask?: string | Function
	moneyMask?: boolean
}>()

const formatCurrency = (value: string): string => {
	const numericValue = parseFloat(value.replace(/[^\d]/g, '')) / 100
	return new Intl.NumberFormat('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(numericValue)
}

const options = reactive<MaskInputOptions>(
	props.mask || props.moneyMask
		? {
				mask: (props.mask as any) ?? undefined,
				postProcess: (value: string) => {
					if (props.moneyMask) {
						if (!value) {
							return 'R$ 0,00'
						}

						return formatCurrency(value)
					}
					return value
				},
		  }
		: {}
)

const handleKeyUp = (event: KeyboardEvent) => {
	if (!inputRef.value || !props.moneyMask) return

	const cursorPosition = inputRef.value.selectionStart!

	if (event.key === 'Backspace' && cursorPosition < 7) {
		inputRef.value.setSelectionRange(7, 7)
	}
}

defineExpose({
	inputRef,
})
</script>
